import { useState } from "react";
import { createKeywords } from "@ts/utils";
import { showToast } from "@ts/modals";
import * as Sentry from "@sentry/react";
import { ICellRendererParams } from "ag-grid-community";
import $ from "jquery"
import { FaCheck, FaTrashAlt } from "react-icons/fa";
import { isTarget } from "@/ts/bulk-keywords-addition";

const UpdateKeywordManualBid = (params: ICellRendererParams) => {
    const identifier = params.data.id;
    const previous_value = params.data.bid;
    let bidValue;
    const [currentBtnState, setCurrentBtnState] = useState(false);
    const [applySpinnerDisp, setApplySpinnerDisp] = useState("none");
    const [trashSpinnerDisp, setTrashSpinnerDisp] = useState("none");

    const applyChange = async () => {
        bidValue = +$(`#bid-update-field-${identifier}`).val();
        const bid = bidValue;
        try {
            const key =
            !isTarget(params.data.target) ? "keywords" : "targets";
            const matchType = key === "keywords" ? "exact" : "asinSameAs";
            const keywordText = isTarget(params.data.target) ? params.data.target : params.data.search_term

            const response = await createKeywords({
                [key]: [
                    {
                        campaignId: params.data.campaign_id,
                        adGroupId: params.data.ad_group_id,
                        programType: params.data.program_type,
                        keywordText: keywordText,
                        matchType,
                        bid: bid,
                        state: "enabled",
                        attribute: ["create_target"]
                    },
                ],
            });
            if (!response.status) {
                throw new Error(response.message);
            }
            showToast("success", response.message);
        } catch (err) {
            console.error(err);
            // inputElement.value = previous_value;
            bidValue = previous_value;
            showToast(
                "danger",
                ` Operation keyword creation failed: ${(err as Error).message}`
            );
            Sentry.captureException(err);
        }
    };

    const applyBtnHandler = async () => {
        setCurrentBtnState(true);
        setApplySpinnerDisp("unset");
        await applyChange();
        setApplySpinnerDisp("none");
        setCurrentBtnState(false);
    };

    const cancelBtnHandler = async function () {
        setCurrentBtnState(true);
        bidValue = previous_value;
        setTrashSpinnerDisp("unset");
        await applyChange();
        setTrashSpinnerDisp("none");
        setCurrentBtnState(false);
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <div
                    className="ag-cell-wrapper updateInput in"
                    id={`bid-update-btn-${identifier}`}
                >
                    <div className="input-group input-group-sm ">
                        <input
                            type="number"
                            id={`bid-update-field-${identifier}`}
                            defaultValue={previous_value}
                            data-id={identifier}
                            className="form-control border border-primary "
                        />

                        <button
                            className="btn btn-light px-2 border-start border-top-0 border-bottom-0 border-primary"
                            type="button"
                            id="applyBtnElement"
                            onClick={applyBtnHandler}
                            disabled={currentBtnState}
                            style={{
                                lineHeight: "1.6",
                            }}
                        >
                            <button
                                className="spinner-border text-primary"
                                style={{
                                    display: `${applySpinnerDisp}`,
                                    zoom: "0.7",
                                    borderWidth: "5px"
                                }}
                            ></button>
                            <FaCheck className="text-primary"
                                style={{
                                    display: `${applySpinnerDisp === "none"
                                        ? "unset"
                                        : "none"
                                        }`,
                                }} />
                        </button>

                        <button
                            className="btn btn-light px-2"
                            type="button"
                            id="cancelBtnElement"
                            onClick={cancelBtnHandler}
                            disabled={currentBtnState}
                            style={{
                                lineHeight: "1.6",
                            }}
                        >
                            <button
                                className="spinner-border"
                                style={{
                                    display: `${trashSpinnerDisp}`,
                                    zoom: "0.7",
                                    borderWidth: "5px"
                                }}
                            ></button>
                            <FaTrashAlt style={{
                                    display: `${trashSpinnerDisp === "none"
                                        ? "unset"
                                        : "none"
                                        }`,
                                }}/>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default UpdateKeywordManualBid;
